import MD5 from 'crypto-js/md5';
import { ConvoArticleCountObj, StorageKeys } from '@Engage.Data.Constants';
import { localStorageService } from '@Engage.Data/services/storage/localStorage/LocalStorageService';
export class ConversationView {
    constructor(data, conversationViewCookieData = {}, convoId = null, convoCode = null) {
        this.viewCount = data.ViewCount || conversationViewCookieData[ConvoArticleCountObj.ArticleCount] || 0;
        this.deviceViewCount = data.DeviceViewCount || conversationViewCookieData[ConvoArticleCountObj.DeviceArticleCount] || 0;
        this.startDate = data.StartDate
            ? new Date(data.StartDate)
            : (conversationViewCookieData[ConvoArticleCountObj.StartDate]
                ? new Date(conversationViewCookieData[ConvoArticleCountObj.StartDate])
                : undefined);
        this.actions = data.Actions;
        this.code = data.Code || convoCode;
        this.id = Number.isInteger(data.Id) ? data.Id : (convoId != null ? convoId : 0);
        this.FreeArticlesRemaining = data.FreeArticlesRemaining || conversationViewCookieData['far'] || 0;
        this.freeArticlesRepeatable = data.freeArticlesRepeatable || conversationViewCookieData['frp'] || [];
    }
    renderCookieObject() {
        return {
            [ConvoArticleCountObj.ArticleCount]: this.viewCount,
            [ConvoArticleCountObj.DeviceArticleCount]: this.deviceViewCount,
            [ConvoArticleCountObj.StartDate]: new Date(this.startDate).getTime(),
            far: this.FreeArticlesRemaining,
            frp: this.freeArticlesRepeatable
        };
    }
    increment() {
        this.viewCount++;
        this.deviceViewCount++;
    }
    reduceArticleCount() {
        if (this.FreeArticlesRemaining > 0) {
            this.setFreeArticleList();
            this.FreeArticlesRemaining--;
        }
    }
    isFreeArticleAvailable() {
        return this.FreeArticlesRemaining;
    }
    setStartDate(date) {
        this.startDate = date;
    }
    getStartDate() {
        return this.startDate;
    }
    getViewCount() {
        return this.viewCount;
    }
    setViewCount(viewCount) {
        this.viewCount = viewCount;
    }
    reset() {
        this.viewCount = 0;
        this.deviceViewCount = 0;
    }
    setFreeArticleList() {
        const articleId = this.getArticleId();
        const list = localStorageService.get(StorageKeys.ConnextFAL, { expandKey: false }) || [];
        list.push(articleId);
        localStorageService.set(StorageKeys.ConnextFAL, list, { expandKey: false });
    }
    getArticleId() {
        return MD5(window.location.href).toString();
    }
}
